module.exports = __webpack_public_path__ + "static/media/ieee_insat_white.033f3ccc.png";